/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import { Icon, useToast } from "@coreai/component-library";
import { useFeedback } from "../../../context/ui/FeedbackModalContext";
import { saveFeedback, TEntityTypes, TFeedbackDetails } from "../../../services/feedbackService";
import { useEffect, useState } from "react";
import { useLanguage } from "LanguageContext";
interface RateFeedbackProps {
    title: string;
    feedbackPosition: string;
    id: string;
    feedbackDetails?: TFeedbackDetails | null;
    feedbackId?: string;
    entityId?: string | null;
    entityType?: TEntityTypes;
  }

export default function RateFeedback(props: Readonly<RateFeedbackProps>) {
  const { toast } = useToast();
  const { t } = useLanguage();
  const theme = useTheme();
  const { title, feedbackPosition, feedbackDetails, id, feedbackId, entityId, entityType  } = props;
  
  const [_reaction, setReaction] = useState<"positive" | "negative" | null>(feedbackDetails?.reaction || null);
  const [_feedbackId, setfeedbackId] = useState<string | undefined>(feedbackDetails?.id || feedbackId);
  const { openFeedback, feedbackDetail } = useFeedback();
  const [_feedbackDetails, setFeedbackDetails] = useState<TFeedbackDetails | null>(feedbackDetail || props?.feedbackDetails || null);

  useEffect(() => {
    if (feedbackDetail) {
      setFeedbackDetails(feedbackDetail);
    }
  }, [feedbackDetail])
  const rateFeedbackWrapperStyles = css`
    display: flex;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
  `;

  const titleStyle = css`
    font-family: ${theme.typography.subbody_medium.fontFamily};
    font-size: ${theme.typography.subbody_medium.fontSize};
    font-weight: ${theme.typography.subbody_medium.fontWeight};
    color: ${theme.colors.feedbackTitleColor};
  `;

  const iconWrapper = css`
    display: flex;
    align-items: center;
    gap: 8px;
  `;

  const iconStyle = css`
    color: ${theme.colors.feedbackTitleColor};
    cursor: pointer;
    &:hover {
      color: ${theme.colors.primary};
    }
  `;

  const activeIconStyle = css`
    color: ${theme.colors.primary};
    cursor: pointer;
  `;

  interface RateFeedbackParams {
    reaction: "positive" | "negative";
    feedbackPosition: string;
    feedbackDetails?: TFeedbackDetails | null;
    id: string;
    entityId?: string | null;
    entityType?: TEntityTypes;
    feedbackId: string | undefined;
  }

  const rateFeedback = ({ reaction, feedbackPosition, feedbackDetails, id, feedbackId, entityId, entityType }: RateFeedbackParams): void => {

    if (reaction === feedbackDetails?.reaction && feedbackDetails?.id === feedbackId) {
      openFeedback(reaction, feedbackPosition, feedbackDetails, feedbackId, entityId, entityType);
      return;
    }

    const obj: any = {
      view: feedbackPosition,
      reaction,
      response_id: id,
    };
    if (feedbackId){
      obj['id'] = feedbackId;
    }
    if (entityId && entityType){
      obj[entityType] = entityId;
    }
    saveFeedback(obj).then((response: any) => {
      if (response?.id) {
        setFeedbackDetails(response);
        setReaction(response?.reaction);
        openFeedback(response?.reaction, feedbackPosition, response, response?.id, entityId, entityType);
        setfeedbackId(response?.id);
        // toast({
        //   variant: 'success',
        //   title: t("feedback_generalInputConfirm"),
        // });
      }      
    }).catch((error: any) => {
      if(error?.response?.status === 404 || error?.response?.status === 403){
        toast({
          variant: 'error',
          title: t("feedback_access_denied"),
        });
      }
      console.log(error);
    });
  };

  return (
    <div css={rateFeedbackWrapperStyles}>
        {props?.title && <div css={titleStyle}>{title}</div>}
        <div css={iconWrapper}>
            <Icon onClick={() => rateFeedback({
              reaction:"positive",
              feedbackPosition,
              feedbackDetails: _feedbackDetails,
              id,
              feedbackId: _feedbackId,
              entityId,
              entityType
            })} name={_reaction === "positive" ? "thumbs-up-filled" : "thumbs-up"} size="sm" css={_reaction === "positive" ? activeIconStyle : iconStyle}/>
            <Icon onClick={() => rateFeedback({
              reaction:"negative",
              feedbackPosition,
              feedbackDetails: _feedbackDetails,
              id,
              feedbackId: _feedbackId,
              entityId,
              entityType
            })} name={_reaction === "negative" ? "thumbs-down-filled" : "thumbs-down"} size="sm" css={_reaction === "negative" ? activeIconStyle : iconStyle}/>
        </div>
    </div>
  );
}
